import { getHttpStatus } from './authState';

export function getLoginErrorMessage(error: unknown): string {
  const status = getHttpStatus(error);

  if (status === 401) {
    return '用户名或密码不正确';
  }

  if (status === 403) {
    return '账号已停用，请联系管理员';
  }

  if (status !== null && status >= 500) {
    return '登录服务暂不可用，请稍后重试';
  }

  return '网络异常，请稍后重试';
}
